// El halo del cursor ACOMPAÑA al punto; no lo persigue.
//
//     node scripts/prueba_cursorQueAcompana.mjs        (desde frontend/)
//
// DE DÓNDE SALE. Gabri, 17 de octubre de 2026, con una captura de la plataforma: *«error de
// cursor que sucede en toda la plataforma. el punto del cursor indica un lugar mientras que el
// círculo se sigue desplazando siguiendo el movimiento real del dedo»*. Y tenía razón en
// llamarlo error aunque estuviera hecho a propósito: el halo iba a `lerp = 0,25` por fotograma,
// que son unos 160 ms hasta alcanzar al punto. A velocidad de trackpad eso no se lee como una
// estela, **se lee como dos cursores**, y el alumno no sabe cuál de los dos marca dónde va a
// pulsar. Un cursor que miente sobre dónde está es peor que no tener cursor propio.
//
// LAS DOS COSAS QUE LO ARREGLAN, Y LA SEGUNDA ES LA QUE IMPORTA:
//
//   · SE ACERCA MÁS DEPRISA. `SUAVE` es la parte del camino que el halo recorre en cada
//     fotograma. A 0,55 llega en tres o cuatro: queda el acompañamiento y se va la cola.
//   · Y NUNCA SE QUEDA MÁS LEJOS QUE `TOPE`. Esto es lo que mata la queja de raíz: por rápido
//     que se mueva la mano, el halo no puede quedarse a más de 40 px del punto —se pega de un
//     salto—. Sin tope, la distancia que alcanza el halo depende de lo rápido que vaya la mano,
//     o sea que **el peor caso no tiene límite**: un gesto brusco los separa media pantalla, y
//     eso es exactamente lo que se ve en la captura.
//
// Y NO SE QUEDA TEMBLANDO A MEDIO PÍXEL: por debajo de `QUIETO` el halo se planta encima del
// punto. Un `lerp` puro nunca llega del todo —se acerca infinitamente—, y eso deja el halo
// vibrando sobre el punto cuando la mano ya está parada, que es otra forma de decir dos cosas.
//
// POR QUÉ ESTO VIVE AQUÍ Y NO EN EL HOOK. Porque es una cuenta, y las cuentas de esta casa se
// prueban sin navegador: su prueba la recorre fotograma a fotograma con movimientos de mano de
// verdad y mide el peor desfase. Dentro del `requestAnimationFrame` sólo se podría mirar.

/** La parte del camino que el halo recorre en cada fotograma. */
export const SUAVE = 0.55;

/** Lo más lejos que el halo puede quedarse del punto, en píxeles. Más que esto, salta. */
export const TOPE = 40;

/** Por debajo de esto ya están en el mismo sitio, y seguir acercándose es temblar. */
export const QUIETO = 0.1;

/**
 * DÓNDE ESTÁ EL HALO EN EL SIGUIENTE FOTOGRAMA. `pos` es donde está, `objetivo` donde está el
 * punto —o sea el ratón—, y lo que devuelve es la posición nueva. Pura: ni lee el reloj ni
 * toca el DOM.
 *
 * `suave` a 1 lo pega al punto, que es lo que hace falta con «Movimiento: reducido» puesto.
 */
export function alcanza(pos, objetivo, { suave = SUAVE, tope = TOPE } = {}) {
  const dx = objetivo.x - pos.x;
  const dy = objetivo.y - pos.y;
  const lejos = Math.sqrt(dx * dx + dy * dy);
  if (lejos > tope || lejos < QUIETO) return { x: objetivo.x, y: objetivo.y };
  return { x: pos.x + dx * suave, y: pos.y + dy * suave };
}

export default alcanza;
